import { render } from "./UserCreateFormFromFile.vue?vue&type=template&id=25f9bdf4&scoped=true"
import script from "./UserCreateFormFromFile.vue?vue&type=script&lang=js"
export * from "./UserCreateFormFromFile.vue?vue&type=script&lang=js"

import "./UserCreateFormFromFile.vue?vue&type=style&index=0&id=25f9bdf4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f9bdf4"]])

export default __exports__